import { render, staticRenderFns } from "./PrivateStudioListItem.vue?vue&type=template&id=92b22f5e&scoped=true&"
import script from "./PrivateStudioListItem.vue?vue&type=script&lang=js&"
export * from "./PrivateStudioListItem.vue?vue&type=script&lang=js&"
import style0 from "./PrivateStudioListItem.vue?vue&type=style&index=0&id=92b22f5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b22f5e",
  null
  
)

export default component.exports